export enum AssetHolder {
  Organization = 'organization',
  VendorAccount = 'vendor_account',
}
